export default {
  listTicker: {
    ORGAN_CODE: 'organCode',
    TICKER: 'ticker',
    ORGAN_SHORT_NAME: 'organShortName',
    COM_GROUP_CODE: 'comGroupCode',
  },

  listIndex: {
    COM_GROUP_CODE: 'comGroupCode',
    COM_GROUP_NAME: 'comGroupName',
    PARENT_COM_GROUP_CODE: 'parentComGroupCode',
  },

  listIndexName: {
    vnIndex: 'VNINDEX',
    hnIndex: 'HNXINDEX',
    upcomIndex: 'UPCOMINDEX',
  },

  listIndexExchange: {
    hose: 'HOSE',
    hnx: 'HNX',
    upcom: 'UPCOM',
  },

  listYear: ['one', 'two', 'three', 'four', 'five'],

  listYearByKey: {
    one: { key: 'one', value: '01' },
    two: { key: 'two', value: '02' },
    three: { key: 'three', value: '03' },
    four: { key: 'four', value: '04' },
    five: { key: 'five', value: '05' },
  },

  defaultYearSelect: 'one',
  typePopUp: {
    peMultiple: 'P/E',
    pbMultiple: 'P/B',
    fcfeCostOfEquity: 'CostOfEquity',
  },
  recommendMethod: {
    pe: 'PE',
    pb: 'PB',
    fcfe: 'FCFE',
  },
};
